import msalInstance from "../authInstance";
import { acquireApiAccessToken } from "./authToken";
import { createApiClient } from "./createApiClient";

const axiosInstance = createApiClient(() => acquireApiAccessToken(msalInstance));

export default axiosInstance;
